import { toast } from 'react-toastify';

const defaultToastConfig = {
  position: "bottom-right", // Default position
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored"
};

export const showToast = (type, message, config = {}) => {
  // Create new config object to avoid modifying the default
  const toastConfig = {
    ...defaultToastConfig,
    ...config,
  };

  // Create container ID based on position
  const containerId = `toast-container-${toastConfig.position}`;

  // Add containerId to config
  toastConfig.containerId = containerId;

  switch (type) {
    case 'success':
      toast.success(message, toastConfig);
      break;
    case 'error':
      toast.error(message, toastConfig);
      break;
    case 'warning':
      toast.warning(message, toastConfig);
      break;
    case 'info':
      toast.info(message, toastConfig);
      break;
    default:
      toast(message, toastConfig);
  }
}; 